
import {getGeneralContent, getProtocalList} from "~/api/privacyPolicy";

export default {
  head:{
    title:'用户协议'
  },
  data(){
    return{
      pageHtml:'',
      showSelect:false,
      acticeIndex:0,
      list:[]
    }
  },
  components:{
    'version-select-box':()=>import("@/components/versionSelectBox.vue")
  },
  methods:{
    changeShow(val){
      this.showSelect=val
    },
    selectFn(index){
      this.acticeIndex = index;
      this.showSelect=false
      this.getContentPage()
    },
    getList(){
      getProtocalList({
        os:'WWW',
        source:'qywz',
        pageSize:1000,
        page:1
      }).then(res=>{
        res.data.list.forEach(item=>{
          item.createTime = item.protocolTime
        })
        this.list = res.data.list
        this.version=this.list[0].version
        this.list.forEach(item=>{
          item.createTime=item.createTime.slice(0,10)
        })
      })
    },
    getContentPage() {
      let params = {
        os:'WWW',
        source:'qywz',
        h5: 'ok'
      }
      if(this.list.length){
        params.version = this.list[this.acticeIndex].version
      }
      this.pageHtml = ''
      getGeneralContent(params).then(res=>{
        if(res.data.protocolContent) {
          this.pageHtml = res.data.protocolContent
        }
      })
    }
  },
  mounted() {
    this.getContentPage()
    this.getList()
  }
}
